module.exports = __webpack_public_path__ + "static/media/AB_N1_15.c4b2fe63.jpg";